import ApiService from './api-service';
import { Integrations } from '../util/constants';

const ConnectService = {
  async getEntitiesSageIntacct({ userId, companyId, userPassword }) {
    const body = {
      query: `mutation getEntitiesSageIntacct($userId: String!, $companyId: String!, $userPassword: String!){
        getEntitiesSageIntacct(userId: $userId, companyId: $companyId, userPassword: $userPassword) {
          entities {
            id
            name
            connected
            disconnected
            isActive
          }
          company {
            id
            name
          }
        }
      }`,
      variables: {
        userId,
        companyId,
        userPassword,
      },
    };

    const data = await ApiService.meEndpoint().post('/', body);
    return data.getEntitiesSageIntacct;
  },
  async connectSageIntacct({ userId, companyId, userPassword, entityIds }) {
    const body = {
      query: `mutation connectSageIntacct($userId: String!, $companyId: String!, $userPassword: String!, $entityIds: [String]!){
        connectSageIntacct(userId: $userId, companyId: $companyId, userPassword: $userPassword, entityIds: $entityIds) {
          ShortCode
        }
      }`,
      variables: {
        userId,
        companyId,
        userPassword,
        entityIds,
      },
    };

    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectSageIntacct;
  },
  async connectSage200({ integrationType }) {
    const body = {
      query: `mutation connectUrl ($accountingSoftware: AccountingSoftwares!, $integrationType: String){
        connect(accountingSoftware: $accountingSoftware, integrationType: $integrationType)
      }`,
      variables: {
        accountingSoftware: Integrations.SAGE200,
        integrationType,
      },
    };

    const data = await ApiService.meEndpoint().post('/', body);
    return data.connect;
  },
  async connectSage200SelectedOrgs({ state, organisationIds }) {
    const body = {
      query: `mutation sage200ConnectOrgs($state: String!, $organisationIds: [String]!) {
        sage200ConnectOrgs(state: $state, organisationIds: $organisationIds) {
          newOrganisations {
            ShortCode
          }
          existingOrganisations {
            ShortCode
          }
        }
      }`,
      variables: {
        state,
        organisationIds,
      },
    };

    const { sage200ConnectOrgs } = await ApiService.baseEndpoint().post('/', body);

    return { data: { sage200ConnectOrgs } };
  },
  async connectOpenAPI({ name, integrationType, sandbox }) {
    const body = {
      query: `mutation connectOpenAPI ($name: String!, $integrationType: IntegrationType, $sandbox: Boolean){
        connectOpenAPI(name: $name, integrationType: $integrationType, sandbox: $sandbox) {
          ShortCode
        }
      }`,
      variables: {
        name,
        integrationType,
        sandbox,
      },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectOpenAPI;
  },
  async connectAccountsIQ({ userKey, organisationID, region }) {
    const body = {
      query: `mutation connectAccountsIQ ($userKey: String!, $organisationID: String!, $region: String!){
        connectAccountsIQ(userKey: $userKey, organisationID: $organisationID, region: $region) {
          ShortCode
        }
      }`,
      variables: {
        userKey,
        organisationID,
        region,
      },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectAccountsIQ;
  },
  async previewAccountsIQ({ userKey, organisationID, region }) {
    const body = {
      query: `query previewAccountsIQ ($userKey: String!, $organisationID: String!, $region: String!){
        previewAccountsIQ(userKey: $userKey, organisationID: $organisationID, region: $region) {
          organisationName
          userEmail
        }
      }`,
      variables: {
        userKey,
        organisationID,
        region,
      },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.previewAccountsIQ;
  },
  async connect(accountingSoftware, shortCode) {
    const body = {
      query: `mutation connectUrl ($accountingSoftware: AccountingSoftwares!, $shortCode: String){
        connect(accountingSoftware: $accountingSoftware, ShortCode: $shortCode)
      }`,
      variables: { accountingSoftware, shortCode },
    };

    const data = await ApiService.meEndpoint().post('/', body);
    return data.connect;
  },
  async connectionSetup({ shortCode, name, country, timezone, currency }) {
    const body = {
      query: `mutation connectionSetup ($shortCode: NonEmptyString!, $name: NonEmptyString!, $country: NonEmptyString!, $timezone: NonEmptyString!, $currency: NonEmptyString!){
        connectionSetup(ShortCode: $shortCode, name: $name, country: $country, timezone: $timezone, currency: $currency) {
          accountingSoftware
          BaseCurrency
          CountryCode
          Name
          name
          timezone
        }
      }`,
      variables: {
        shortCode,
        name,
        country,
        timezone,
        currency,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data.connectionSetup;
  },
  async previewCSV({ sftpConfiguration, shortCode }) {
    const body = {
      query: /* GraphQL */ `
        query previewCSV($sftpConfiguration: CSVConfigurationSFTPInputType, $shortCode: String) {
          previewCSV(sftpConfiguration: $sftpConfiguration, shortCode: $shortCode) {
            fileNames
            readyToConnect
          }
        }
      `,
      variables: { sftpConfiguration, shortCode },
    };

    const data = await ApiService.meEndpoint().post('/', body);
    return data.previewCSV;
  },
  async connectCSV({ sftpConfiguration }) {
    const body = {
      query: /* GraphQL */ `
        mutation connectCSV($sftpConfiguration: CSVConfigurationSFTPInputType) {
          connectCSV(sftpConfiguration: $sftpConfiguration) {
            ShortCode
          }
        }
      `,
      variables: { sftpConfiguration },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectCSV;
  },
  async updateCSV({ sftpConfiguration, ShortCode }) {
    const body = {
      query: /* GraphQL */ `
        mutation updateCSV($sftpConfiguration: CSVConfigurationSFTPInputType, $ShortCode: String!) {
          updateCSV(sftpConfiguration: $sftpConfiguration, ShortCode: $ShortCode)
        }
      `,
      variables: { sftpConfiguration, ShortCode },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectCSV;
  },
  async connectManualCSV() {
    const body = {
      query: /* GraphQL */ `
        mutation connectManualCSV {
          connectManualCSV {
            ShortCode
          }
        }
      `,
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectManualCSV;
  },
  async getOdooCompanies({ odooConfiguration }) {
    const body = {
      query: /* GraphQL */ `
        query getOdooCompanies($odooConfiguration: OdooConfigurationInputType!) {
          getOdooCompanies(odooConfiguration: $odooConfiguration) {
            id
            name
          }
        }
      `,
      variables: { odooConfiguration },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.getOdooCompanies;
  },
  async connectOdoo({ odooConfiguration }) {
    const body = {
      query: /* GraphQL */ `
        mutation connectOdoo($odooConfiguration: OdooConfigurationInputType!) {
          connectOdoo(odooConfiguration: $odooConfiguration) {
            ShortCode
          }
        }
      `,
      variables: { odooConfiguration },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectOdoo;
  },
  async updateOdoo({ odooConfiguration, ShortCode }) {
    const body = {
      query: /* GraphQL */ `
        mutation updateOdoo($odooConfiguration: OdooConfigurationInputType!, $ShortCode: String!) {
          updateOdoo(odooConfiguration: $odooConfiguration, ShortCode: $ShortCode)
        }
      `,
      variables: { odooConfiguration, ShortCode },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.updateOdoo;
  },
  async connectStripe({ stripeToken }) {
    const body = {
      query: /* GraphQL */ `
        mutation connectStripe($stripeToken: String!) {
          connectStripe(stripeToken: $stripeToken) {
            ShortCode
          }
        }
      `,
      variables: { stripeToken },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectStripe;
  },
  async previewStripe({ stripeToken }) {
    const body = {
      query: /* GraphQL */ `
        query previewStripe($stripeToken: String!) {
          previewStripe(stripeToken: $stripeToken) {
            organisationName
          }
        }
      `,
      variables: { stripeToken },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.previewStripe;
  },
  async getSubsidiariesNetSuite ({code, state, company, entity}) {
    const body = {
      query: /* GraphQL */ `
        mutation getSubsidiariesNetSuite(
          $code: String!
          $state: String!
          $company: String!
          $entity: String!
        ) {
          getSubsidiariesNetSuite(code: $code, state: $state, company: $company, entity: $entity) {
            state
            existing
            groupSubsidiaries
            subsidiaries {
              id
              name
              parent
              connected
              disconnected
            }
          }
        }
      `,
      variables: {
        code,
        state,
        company,
        entity,
      },
    };

    const data = await ApiService.meEndpoint().post('/', body);

    return data.getSubsidiariesNetSuite;
  },
  async connectNetSuite ({state, subsidiaryIds, groupSubsidiaries}) {
    const body = {
      query: /* GraphQL */ `
        mutation connectNetSuite(
          $state: String!
          $subsidiaryIds: [String]!
          $groupSubsidiaries: Boolean!
        ) {
          connectNetSuite(
            state: $state
            subsidiaryIds: $subsidiaryIds
            groupSubsidiaries: $groupSubsidiaries
          ) {
            newOrganisations {
              ShortCode
            }
            existingOrganisations {
              ShortCode
            }
          }
        }
      `,
      variables: {
        state,
        subsidiaryIds,
        groupSubsidiaries,
      },
    };

    const data = await ApiService.meEndpoint().post('/', body);
    return data.connectNetSuite;
  }
};

export default ConnectService;
